import { Settings } from "lucide-react"
import { Button } from "@/components/ui/button"
import type { SynthesisSession } from "../../domain/entities/synthesis-session"

type SynthesisSessionHeaderProps = {
  title: string
  session: SynthesisSession | undefined
  sessionLoading: boolean
  onOpenSettings: () => void
}

export const SynthesisSessionHeader = ({
  title,
  session,
  sessionLoading,
  onOpenSettings,
}: SynthesisSessionHeaderProps) => (
  <div className="flex shrink-0 items-center justify-between border-b border-border px-4 py-3">
    <h1 className="truncate text-lg font-semibold">{title}</h1>
    <div className="flex gap-1">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label="Conversation settings"
        disabled={!session || sessionLoading}
        onClick={onOpenSettings}
      >
        <Settings className="size-4" />
      </Button>
    </div>
  </div>
)
